import React from 'react'

import { defaultGetPageName } from '../../components/Post/utils'

import defaultPostTypeConfig from '../post'

import getConstants from './constants'
import FilterForm from './FilterForm'

function getCustomValidationForDate() {
    return function customValidationForDate(p) {

        const {
            showInitializationErrors,
            messages,
            name
        } = p

        return function custom(value, changedEver) {
            const regex = /^\d{4}-\d{2}-\d{2}$/

            if ((changedEver || (!changedEver && showInitializationErrors))) {
                if (value) {
                    if (!regex.test(value)) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDateFormat']
                        }
                    }

                    const d = new Date(value)
                    if (isNaN(d.getTime())) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDate']
                        }
                    }

                    const [yyyy, mm, dd] = value.split('-').map(Number)
                    if (d.getUTCFullYear() !== yyyy || (d.getUTCMonth() + 1) !== mm || d.getUTCDate() !== dd) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDate']
                        }
                    }
                }
            }

            return { error: false, errorMessage: '' }
        }

    }
}

const postTypeConfig = {
    getStatusManager: function getStatusManager(p = {}) {
        return defaultPostTypeConfig.getStatusManager({
            ...p,
            config: {
                requiredDataForStatus: {
                    notification: { type: Object }
                },
                ...(p.config) ? p.config : {}
            }
        })
    },
    getConstants: getConstants,
    setContents: function setContents(p = {}) {
        const name = 'review'

        const { wapp } = p

        const r = defaultPostTypeConfig.setContents({
            ...p,
            name,
            urlParams: [
                '/page/:pagination',
                '/sort/:sort',
                '/limit/:limit'
            ],
            transformRequestParams: ({ requestParams }) => {
                if (requestParams.requestName === name + 'FindMany') {
                    requestParams.args.filter.autoCompleteOnDismiss = false
                }
                return requestParams
            }
        })

        const contentProps = wapp.contents.get(name)

        wapp.contents.add({
            [name]: {
                ...contentProps,
                robots: () => {
                    return 'noindex,nofollow'
                }
            }
        })

        return r
    },
    requestForUserPage: async function requestForUserPage(p = {}) {
        return await defaultPostTypeConfig.requestForUserPage({
            ...p,
            name: 'review',
            transformRequestParams: ({ requestParams }) => {
                requestParams.args.filter.autoCompleteOnDismiss = false
                return requestParams
            }
        })
    },
    getComponent: function(p) {

        const name = 'review'

        const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'

        const { context, appContext } = p
        const { routes } = appContext

        const { res, req } = context
        const route = res.wappResponse.route
        const requestPath = route.requestPath
        const user = req.wappRequest.user

        const isAdmin = user && user._status_isFeatured

        if ((requestPath.startsWith(routes[name + 'Route'])) || (requestPath.startsWith(routes[ns + 'Route']))) {

            const pages = {}

            if (requestPath.startsWith(routes[ns + 'Route']) && !isAdmin) {
                return null
            }

            const requestKeys = [name + 'FindById']
            const post = requestKeys.map((requestName) => res.wappResponse.store.getState('res.responses.' + requestName)).find((r) => r?._id)
            const isAuthor = ((user?._id && user._id.toString() === post?._author) || (user?._id && user._id.toString() === post?._author?._id))

            const isAuthorOrAdmin = (isAuthor || isAdmin)

            if (requestPath.startsWith(routes[name + 'Route']) && requestPath !== routes[name + 'Route'] + '/new' && !isAuthorOrAdmin) {
                return null
            }

            return defaultPostTypeConfig.getComponent({
                ...p,
                name,
                archiveComponentProps: {
                    type: 'list',
                    selectable: () => false,
                    selectFunctions: [],
                    getMenu: () => [],
                    disableSearch: true,
                    ListToolsProps: {
                        filterProps: {
                            Form: FilterForm,
                            formProps: {
                                formData: {
                                    row1: {
                                        isContainer: true,
                                        hiddenContainer: true
                                    },
                                    ['completed']: {
                                        schemaType: 'Boolean',
                                        containerKey: 'row1.completed',
                                        label: appContext.labels[ns + 'FilterCompleted'],
                                        placeholder: appContext.labels[ns + 'FilterCompletedPlaceholder'],
                                        options: [
                                            {
                                                label: appContext.labels[ns + 'FilterCompletedOption1'],
                                                value: 'true'
                                            },
                                            {
                                                label: appContext.labels[ns + 'FilterCompletedOption2'],
                                                value: 'false'
                                            }
                                        ]
                                    },
                                    ['value']: {
                                        schemaType: 'Number',
                                        containerKey: 'row1.value',
                                        label: appContext.labels[ns + 'FilterValue'],
                                        placeholder: appContext.labels[ns + 'FilterValuePlaceholder'],
                                        validations: {
                                            numberRange: {
                                                min: 1,
                                                max: 100
                                            }
                                        }
                                    },
                                    lastAttemptAt: {
                                        isContainer: true,
                                        hiddenContainer: true
                                    },
                                    ['_operators.lastAttemptAt.gt']: {
                                        containerKey: 'lastAttemptAt._lastAttemptAtGt',
                                        label: appContext.labels[ns + 'FilterLastAttemptAtFrom'],
                                        helperText: '2001-01-01',
                                        validations: {
                                            custom: getCustomValidationForDate()
                                        }
                                    },
                                    ['_operators.lastAttemptAt.lt']: {
                                        containerKey: 'lastAttemptAt._lastAttemptAtLt',
                                        label: appContext.labels[ns + 'FilterLastAttemptAtTo'],
                                        helperText: '2001-01-01',
                                        validations: {
                                            custom: getCustomValidationForDate()
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                componentProps: {
                    pages,
                    showAuthor: ({ user }) => user?._status_isFeatured,
                    getPageName: (props) => {
                        const r = defaultGetPageName(props)
                        if (r === 'new' || r === 'edit' || r === 'content') {
                            return null
                        }
                        return r
                    },
                    getMenu: () => []
                }
            })
        }
    },
    userPageFunctions: function(p) {

        const { context } = p

        const n = 'review'
        const ns = (n.endsWith('y')) ? n.slice(0, -1) + 'ies' : n + 's'

        const { res } = context

        const wappResponse = res.wappResponse
        const route = wappResponse.route
        const { params } = route
        const { pageType } = params

        const r = defaultPostTypeConfig.userPageFunctions({
            ...p,
            name: n,
            nsPageProps: {
                selectable: () => false,
                selectFunctions: [],
                getMenu: () => [],
                disableSearch: true,
                type: 'list'
            }
        })

        function addMenuItems() {
            return []
        }

        function addContentMenuItems() {
            return []
        }

        function getPageName({ user, page }) {

            const isAdmin = user && user._status_isFeatured

            return (
                (page === ns && !pageType) ||
                (page === ns && !isNaN(Number(pageType)) && Number(pageType) >= 1)
            ) ? (isAdmin) ? page : 'notFound' : null

        }

        return {
            ...r,
            addMenuItems,
            addContentMenuItems,
            getPageName
        }
    },
    adminMenu: function() {
        return []
    }
}

export default postTypeConfig
